import clsx from "clsx";

interface FieldRow50Props {
  options: Array<{
    label: string;
    value: string;
    isRequired?: boolean;
  }>;
  rowStyle?: string;
  inputStyle?: string;
}

export default function FieldRow50({
  options,
  rowStyle,
  inputStyle,
}: FieldRow50Props) {
  return (
    <div className={clsx("flex flex-col lg:flex-row lg:gap-7", rowStyle)}>
      {options.map(({ label, value, isRequired }, index) => (
        <div
          key={value}
          className={`flex-1 ${index > 0 ? "pt-6 lg:pt-0" : ""}`}
        >
          <label htmlFor={value} className="font-bold">
            {label} {isRequired && <span>*</span>}
          </label>
          <input
            id={value}
            name={value}
            type={"text"}
            required={isRequired}
            title="Please enter at least 2 letters."
            placeholder={label}
            className={inputStyle}
          />
        </div>
      ))}
    </div>
  );
}
